module.exports = __webpack_public_path__ + "img/sp2.d2af32d5.png";